<div class="tudoc-tracking">
  <div class="tt-header">
    <div>
      <h2>🎯 Tracking TuDoc — Recuperacion de clientes</h2>
      <p class="subtitle">1 fila por persona con su ultimo paso alcanzado. Contacta a los que no completaron para recuperarlos.</p>
    </div>
  </div>

  <!-- Filtros -->
  <div class="tt-filters">
    <div class="filter">
      <label>Desde</label>
      <input type="date" [(ngModel)]="startDate" />
    </div>
    <div class="filter">
      <label>Hasta</label>
      <input type="date" [(ngModel)]="endDate" />
    </div>
    <div class="filter">
      <label>Ultimo step</label>
      <select [(ngModel)]="stepFilter">
        <option value="">Todos</option>
        <option *ngFor="let s of availableSteps" [value]="s">{{ stepLabel(s) }}</option>
      </select>
    </div>
    <div class="filter search">
      <label>Buscar</label>
      <input type="text" placeholder="cedula o nombre" [(ngModel)]="searchQuery" />
    </div>
    <div class="filter actions">
      <button class="btn-primary" (click)="applyFilters()">Aplicar</button>
      <button class="btn-secondary" (click)="clearFilters()">Limpiar</button>
    </div>
  </div>

  <!-- KPIs -->
  <div class="tt-kpis" *ngIf="!loadingSummary && kpis">
    <div class="kpi-card started">
      <div class="kpi-label">Iniciaron el flujo</div>
      <div class="kpi-value">{{ kpis.personsStarted | number }}</div>
      <div class="kpi-foot">personas distintas</div>
    </div>
    <div class="kpi-card completed">
      <div class="kpi-label">Completaron</div>
      <div class="kpi-value">{{ kpis.personsCompleted | number }}</div>
      <div class="kpi-foot">activacion OK</div>
    </div>
    <div class="kpi-card abandoned">
      <div class="kpi-label">Abandonaron</div>
      <div class="kpi-value">{{ kpis.personsAbandoned | number }}</div>
      <div class="kpi-foot">candidatos a recuperar</div>
    </div>
    <div class="kpi-card conversion">
      <div class="kpi-label">Tasa de conversion</div>
      <div class="kpi-value">{{ kpis.conversionRatePct | number:'1.0-2' }}%</div>
      <div class="kpi-foot">completaron / iniciaron</div>
    </div>
    <div class="kpi-card revenue">
      <div class="kpi-label">Revenue perdido</div>
      <div class="kpi-value">${{ kpis.revenueLostUsd | number:'1.2-2' }}</div>
      <div class="kpi-foot">USD estimado</div>
    </div>
  </div>

  <div *ngIf="loadingSummary" class="loading">Cargando KPIs...</div>

  <!-- Funnel horizontal -->
  <div class="tt-funnel" *ngIf="!loadingSummary && funnel.length">
    <h3>Funnel — drop-off por step</h3>
    <div class="funnel-rows">
      <div class="funnel-row" *ngFor="let s of funnel">
        <div class="funnel-label">{{ stepLabel(s.step) }}</div>
        <div class="funnel-bar-track">
          <div class="funnel-bar" [style.width.%]="funnelBarWidth(s.count)"></div>
        </div>
        <div class="funnel-count">{{ s.count | number }}</div>
      </div>
    </div>
  </div>

  <!-- Tabla de clientes abandonados -->
  <div class="tt-table">
    <div class="table-header">
      <h3>Clientes abandonados ({{ pagination.totalItems | number }})</h3>
    </div>

    <div *ngIf="loadError" class="error-banner">{{ loadError }}</div>
    <div *ngIf="loadingClients" class="loading">Cargando clientes...</div>

    <div class="table-wrap" *ngIf="!loadingClients">
      <table>
        <thead>
          <tr>
            <th>Cedula</th>
            <th>Nombre</th>
            <th>Telefono</th>
            <th>Ultimo step</th>
            <th>Cuando</th>
            <th>Intentos</th>
            <th>Meses</th>
            <th>Monto</th>
            <th class="acciones">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of filteredClients">
            <td>{{ c.nacionalidad || '' }}{{ c.cedula || '-' }}</td>
            <td>{{ (c.nombre || '') + ' ' + (c.apellidos || '') }}</td>
            <td>{{ c.phone || '-' }}</td>
            <td>
              <span class="badge" [ngClass]="stepBadgeClass(c.last_step)">
                {{ stepLabel(c.last_step) }}
              </span>
            </td>
            <td>
              <div class="time-cell">
                <span class="time-relative">hace {{ timeAgo(c.last_step_at) }}</span>
                <span class="time-abs">{{ formatDateShort(c.last_step_at) }}</span>
              </div>
            </td>
            <td>
              <span class="attempts" *ngIf="c.attempts > 1">{{ c.attempts }} intentos</span>
              <span *ngIf="c.attempts === 1">1 intento</span>
            </td>
            <td>{{ clientMonths(c) }}</td>
            <td>{{ clientAmount(c) }}</td>
            <td class="acciones">
              <button class="cta-btn cta-call" title="Llamar" [disabled]="!c.phone" (click)="ctaCall(c)">📞</button>
              <button class="cta-btn cta-wa" title="WhatsApp" [disabled]="!c.phone" (click)="ctaWhatsApp(c)">💬</button>
              <button class="cta-btn cta-mail" title="Email" [disabled]="!c.email" (click)="ctaEmail(c)">✉️</button>
            </td>
          </tr>
          <tr *ngIf="filteredClients.length === 0">
            <td colspan="9" class="empty">
              <span *ngIf="clients.length === 0">Ningun cliente abandonado en este rango. 🎉</span>
              <span *ngIf="clients.length > 0">Ningun cliente matchea la busqueda.</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginacion -->
    <div class="pagination" *ngIf="pagination.totalPages > 1">
      <button (click)="changePage(pagination.currentPage - 1)" [disabled]="pagination.currentPage <= 1">← Anterior</button>
      <span>Pagina {{ pagination.currentPage }} de {{ pagination.totalPages }}</span>
      <button (click)="changePage(pagination.currentPage + 1)" [disabled]="pagination.currentPage >= pagination.totalPages">Siguiente →</button>
    </div>
  </div>
</div>
